import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import SubmitButton from "components/common/SubmitButton";

const EditSupplierCategory = (props) => {
  const IS_EDIT = Boolean(props.editItem);
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  const validateForm = (values) => {
    const errors = {};
    if (!values.categoryName || values.categoryName.trim() === "") {
      errors.categoryName = "Category name is required";
    }
    return errors;
  };

  return (
    <Dialog
      title={
        IS_EDIT
          ? `Edit ${props.editItem?.categoryName}`
          : "Add Supplier Category"
      }
      onClose={props.cancelEdit}
      width={600}
    >
      <Form
        onSubmit={props.onSubmit}
        initialValues={{
          active: true,
          ...props.editItem,
        }}
        validator={validateForm}
        render={(formRenderProps) => (
          <>
            <div className="p-3 ps-4">
              <FormElement>
                <fieldset className="k-form-fieldset">
                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">
                      Category Name
                    </Label>
                    <Field
                      name="categoryName"
                      component={Input}
                      placeholder="Enter category name"
                    />
                    {submitAttempted &&
                      formRenderProps.errors?.categoryName && (
                        <div className="fs-sm my-1 text-danger">
                          <i>{formRenderProps.errors.categoryName}</i>
                        </div>
                      )}
                  </div>

                  <div className="mt-2">
                    <Field name="active" component={Checkbox} label="Active" />
                  </div>
                </fieldset>
              </FormElement>
            </div>
            <div className="dialog-footer">
              <button
                className="bgBtnSecondary common-btn me-2"
                onClick={props.cancelEdit}
              >
                Cancel
              </button>
              <SubmitButton
                className="me-3"
                isLoading={props.isSubmitting}
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
                disabled={!formRenderProps.allowSubmit}
              >
                {IS_EDIT ? "Update" : "Save"}
              </SubmitButton>
            </div>
          </>
        )}
      />
    </Dialog>
  );
};

export default EditSupplierCategory;
